// extracted by css-extract-rspack-plugin
export default {"item":"SelectItem-module__item___g9syb"};